module.exports = __webpack_public_path__ + "img/album18_50.d052a59d.jpg";